import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Logo } from "../components/Logo";
import { Spinner } from "../components/Spinner";

export function Signup() {
  const nav = useNavigate();
  const { signup } = useAuth();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try { await signup(email, pw); nav("/dashboard"); }
    catch (e: any) { setErr(humanError(e?.message)); }
    finally { setLoading(false); }
  }

  return (
    <div className="mx-auto grid min-h-[80vh] max-w-md place-items-center px-4">
      <div className="w-full">
        <div className="mb-6 flex items-center gap-2 text-white/90"><Logo className="h-6 w-6" /><span className="font-semibold">Motion</span></div>
        <h1 className="text-2xl font-semibold tracking-tight text-white">Create your account</h1>
        <p className="text-sm text-white/50">Free, no credit card. Browser exports are unlimited.</p>
        <form className="mt-6 space-y-3" onSubmit={onSubmit}>
          <label className="block">
            <span className="mb-1 block text-xs text-white/60">Email</span>
            <input className="field" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label className="block">
            <span className="mb-1 block text-xs text-white/60">Password</span>
            <input className="field" type="password" autoComplete="new-password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} />
            <span className="mt-1 block text-[11px] text-white/30">Minimum 8 characters. Stored hashed with scrypt N=2¹⁶.</span>
          </label>
          {err && <div className="rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-300">{err}</div>}
          <button className="btn-primary w-full py-2.5" disabled={loading} type="submit">
            {loading ? <Spinner /> : "Create account"}
          </button>
        </form>
        <p className="mt-4 text-sm text-white/50">
          Already have one? <Link to="/login" className="text-white underline-offset-2 hover:underline">Log in</Link>.
        </p>
      </div>
    </div>
  );
}

function humanError(code?: string) {
  if (code === "email_taken") return "That email is already in use.";
  if (code === "rate_limited") return "Too many attempts. Wait a minute and try again.";
  return code ?? "Something went wrong. Try again.";
}
